exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#copy-editor-page .search-bar{flex-grow:0}#copy-editor-page .search-bar-container{height:2rem;border-radius:.25rem .25rem 0 0;padding:1em 0 2em}", ""]);

// exports
